var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"errorBlock text-center p-3"},[_c('b-col',[_vm._v(" Chyba aplikace.")]),_c('b-col',[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }